import { render, staticRenderFns } from "./NormalDetailForm.vue?vue&type=template&id=30dbd13d&scoped=true"
import script from "./NormalDetailForm.vue?vue&type=script&lang=js"
export * from "./NormalDetailForm.vue?vue&type=script&lang=js"
import style0 from "./NormalDetailForm.vue?vue&type=style&index=0&id=30dbd13d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30dbd13d",
  null
  
)

export default component.exports